import { useState } from "react";
import { Avatar } from "antd";
import { MdPerson } from "react-icons/md";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import "shared/styles/app.global.scss";
import { useUser } from "shared/contexts/user-context";

import styles from "./create-post.module.scss";
import CreatePostModal from "./CreatePostModal";
import PostToggleButton from "../PostToggleButton/PostToggleButton";

export default function CreatePost() {
  const { t } = useTranslation();

  const { user } = useUser();

  const [isCreatePostModalOpen, setIsCreatePostModalOpen] = useState(false);

  return (
    <>
      {isCreatePostModalOpen && (
        <CreatePostModal
          isOpen={isCreatePostModalOpen}
          onClose={() => setIsCreatePostModalOpen(false)}
        />
      )}

      <div
        className={clsx("feedContainer", "container")}
        onClick={() => setIsCreatePostModalOpen(true)}
      >
        <div className={styles.clickContainer}>
          {" "}
          <Avatar
            src={user.image}
            icon={
              <MdPerson
                style={{
                  marginTop: ".25rem",
                }}
              />
            }
            style={{
              cursor: "pointer",
            }}
          />
          <div className={styles.createContainer}>
            <h3>{t("create post")}</h3>
          </div>
          <PostToggleButton />
        </div>
      </div>
    </>
  );
}
